import React from 'react';
import PropTypes from 'prop-types';

const Svg = ({
  className,
  icon,
  viewBox,
}) => (
  <svg className={className} viewBox={viewBox}>
    <use xlinkHref={`#sprite_${icon}`} />
  </svg>
);

Svg.defaultProps = {
  viewBox: null,
  className: null,
};

Svg.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  viewBox: PropTypes.string,
};

export default Svg;
